import { NavLink } from "react-router-dom";

const EmptyState = ({ title, route, icon, desc }: { title: string; route: string; icon: string, desc: string }) => {
  return (
      <div className='border-2 border-gray-300 border-round-lg p-3 h-full'>
          <div className="flex justify-content-between md:gap-0 gap-3">
              <span className="font-bold flex-1">{title}</span>
              <NavLink to={route} className={"no-underline "}>
                  <div className="flex gap-2 align-items-center" style={{ color: "#EA088B" }}>
                      <span className="font-bold text-sm">View all</span>
                      <i className="pi pi-chevron-right text-xs"></i>
                  </div>
              </NavLink>
          </div>
          <div className="m-8 flex flex-column gap-3 align-items-center">
              <i className={`text-3xl ${icon}`} style={{ color: "#EA088B" }}></i>
              <span className="text-center text-sm">{desc}</span>
          </div>
    </div>
  )
}

export default EmptyState;
